import { jsxs as r, jsx as c } from "react/jsx-runtime";
import { E as f, S as v } from "./icons.types-0722eef5.js";
function E({ title: n, titleId: h, size: l, width: o, height: s, extended: i = !1, ...t }) {
  const a = i ? f : v, d = l ? a[l] : o || a[i ? "s" : "l"], e = l ? a[l] : s || a[i ? "s" : "l"];
  return /* @__PURE__ */ r(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 72 72",
      width: d,
      height: e,
      "aria-labelledby": h,
      ...t,
      children: [
        n ? /* @__PURE__ */ c("title", { id: h, children: n }) : null,
        /* @__PURE__ */ c(
          "path",
          {
            fill: "#E6E7E8",
            d: "M20 14h32v44H20V14Z"
          }
        ),
        /* @__PURE__ */ c(
          "path",
          {
            fill: "#EC1C24",
            d: "M14 14C7.373 14 4 18.925 4 25v22c0 6.075 3.373 11 10 11h6V14h-6Zm44 0h-6v44h6c6.627 0 10-4.925 10-11V25c0-6.075-3.373-11-10-11Z"
          }
        ),
        /* @__PURE__ */ c(
          "path",
          {
            fill: "#EC1C24",
            fillRule: "evenodd",
            d: "M48.26 35.641c-.457-.207-.534-.353-.398-.858.339-1.263.688-2.521 1.031-3.782.029-.103.055-.209.094-.36-.424.085-.82.161-1.216.247-.801.17-1.597.343-2.396.512-.522.109-.761-.037-.909-.553-.139-.488-.276-.977-.499-1.535-.051.084-.088.181-.153.252a1144.37 1144.37 0 0 1-2.756 3.096c-.285.314-.602.451-.826.327-.329-.186-.317-.515-.263-.822.243-1.341.495-2.679.745-4.02.183-.973.366-1.941.554-2.955-.095.036-.159.054-.216.082-.518.268-1.03.541-1.549.803-.636.319-.956.214-1.288-.401-.703-1.303-1.4-2.608-2.101-3.912-.036-.064-.06-.128-.115-.21l-.115.21c-.698 1.305-1.398 2.609-2.099 3.912-.333.615-.654.721-1.29.401-.519-.262-1.031-.535-1.549-.803-.057-.028-.121-.046-.216-.082.188 1.014.371 1.982.554 2.955.25 1.337.503 2.675.744 4.02.056.308.067.637-.262.822-.225.124-.541-.013-.825-.327-.923-1.032-1.842-2.064-2.757-3.096-.065-.071-.103-.168-.153-.252-.223.559-.36 1.047-.499 1.535-.148.516-.389.662-.909.553l-2.396-.512c-.396-.086-.792-.162-1.216-.247.039.151.064.258.094.36.343 1.261.692 2.52 1.031 3.782.136.506.059.651-.398.858-.423.192-.845.395-1.292.604.08.072.125.115.175.156l3.194 2.595c1.031.838 2.058 1.675 3.09 2.51.361.291.48.645.331 1.087-.084.26-.159.52-.237.781-.094.307-.186.616-.29.967 1.023-.145 1.989-.28 2.962-.415 1.141-.157 2.281-.318 3.425-.462.392-.051.683.248.667.637-.086 2.063-.285 4.392-.299 6.346h1.07c-.014-1.954-.212-4.282-.298-6.346-.018-.389.274-.688.666-.637 1.144.144 2.284.305 3.425.462.973.135 1.939.271 2.962.415-.104-.351-.196-.66-.29-.967-.078-.262-.153-.521-.237-.781-.149-.442-.03-.796.331-1.087 1.033-.835 2.059-1.672 3.09-2.51l3.194-2.595c.05-.041.095-.084.175-.156-.448-.21-.868-.412-1.292-.604Z",
            clipRule: "evenodd"
          }
        )
      ]
    }
  );
}
export {
  E as CanCanada
};
